import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { shippingAddressStyles } from "@dana/Widgets/OrderDetails/OrderDetailsSoldToAddress";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

shippingAddressStyles.wrapper = mergeToNew(shippingAddressStyles.wrapper, {
  width: 12,
  css: css`
    display: flex;
    width: 100%;
    max-width: 100%;
    flex-direction: column;
    padding: 0px;
  `
});


shippingAddressStyles.titleText = mergeToNew(shippingAddressStyles.titleText, {
  css: css`
    margin-bottom: 0px;
    background: ${themeBackgrounds.lightGray};
    padding: 4px;
    width: 100%;
  `
});

shippingAddressStyles.addressDisplay = mergeToNew(shippingAddressStyles.addressDisplay, {
  wrapper: {
    css: css`
        padding: 4px;
    `,
},
});